export default __webpack_public_path__ + "06.01.2016_Pressemitteilung_LifeTime_Seedfinanzierung6c07cfae45486a2f1acf29bd3f18f748.pdf";